'use client';

import { createRouteError } from '@components/feedback/route-error';

export default createRouteError('Error in /[organization_id] page:');
